import { useTranslation } from 'react-i18next'
import { Button } from '@repo/ui'
import { MarkRedrawnIcon24 } from '@repo/ui/icons'
import { useDialog } from '@/components/common/dialog'
import { BfnStoreDataEntry } from '@/store/useBfnStore'
import BfnManuellWiderrufenDialog from '@/features/befehlsnachrichten/components/dialogs/BfnManuellWiderrufenDialog'

export interface BfnAnyStatusActionsProps {
  data: BfnStoreDataEntry
  'data-testid': string
}

export default function BfnManuellWiderrufenAction({
  data,
  'data-testid': testId
}: Readonly<BfnAnyStatusActionsProps>) {
  const { t } = useTranslation('bfnDetails')
  const [
    isManuellWiderrufenDialogOpen,
    openManuellWiderrufenDialog,
    closeManuellWiderrufenDialog
  ] = useDialog()
  return (
    <>
      <BfnManuellWiderrufenDialog
        befehlsnachricht={data.befehlsnachricht}
        state={isManuellWiderrufenDialogOpen}
        onClose={closeManuellWiderrufenDialog}
        data-testid={`${testId}-dialog`}
      />

      <Button
        variant="secondary-solid"
        className="w-full"
        onClick={() => openManuellWiderrufenDialog()}
        data-testid={`${testId}-button`}
      >
        <MarkRedrawnIcon24
          className="shrink-0"
          data-testid={`${testId}-button-icon`}
        />
        <span className="pl-0.5" data-testid={`${testId}-button-text`}>
          {t('actions.manuell_widerrufen_button')}
        </span>
      </Button>
    </>
  )
}
